export default "__VITE_ASSET__Cxy8City__"